<template>
  <main class="work">
    <div class="work__filters">
      <filters @filterBy="filter"/>
      <h5 v-if="loading">Loading...</h5>
      <h5 v-if="!loading && payload && !payload.work">No projects found</h5>
    </div>
    <div
      v-if="payload && payload.work"
      class="work__items">
      <work-item
        v-for="(item, key) in payload.work"
        :key="`work${key}`"
        :item="item"></work-item>
    </div>
  </main>
</template>

<script>
import ApiPage from '@/services/ApiPage'
import Filters from '@/views/work/Filters'
import WorkItem from '@/views/work/WorkItem'

export default {
  name: 'home',
  extends: ApiPage,
  components: {
    Filters,
    WorkItem
  },
  data() {
    return {
      payload: null,
      loading: true,
      filters: {}
    }
  },
  mounted() {
    this.loading = false
  },
  watch: {
    payload: function(val) {
      if (val) {
        setTimeout(() => {
          window.scrollTo({
            top: this.$store.getters.getWorkScroll,
            left: 0,
            behavior: 'smooth'
          })
        }, 500)
      }
    }
  },
  methods: {
    async filter(type, value) {
      // add loading
      this.loading = true
      this.payload = null

      // add filter to filters
      this.filters[type] = value

      // remove type if all
      if (value.toLowerCase().substring(0, 3) === 'all') delete this.filters[type]

      this.payload = await this.getFilteredWork()
      this.loading = false
    },
    getFilteredWork() {
      let url = `${process.env.VUE_APP_SITE}/api/wp-admin/admin-ajax.php`

      return new Promise(resolve => {
        this.$http.post(url, { action: 'work', ...this.filters })
          .then(response => response.json())
          .then(result => resolve(result))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.work {
  @include page;
  &__items {
    display:flex;
    flex-wrap:wrap;
    // justify-content: space-between;
  }
}
</style>
